export default function PageShell({ title, titleAppendix, actions, children }) {
  return (
    <>
      <div className="flex justify-between items-center flex-grow min-h-16">
        <div className="flex gap-3 items-center">
          {title && <h1 className="text-4xl">{title}</h1>}
          {titleAppendix}
        </div>
        {actions && <div className="flex gap-2 items-center">{actions}</div>}
      </div>
      <div className="w-full h-full overflow-auto">{children}</div>
    </>
  );
}
